/**
 * mc-precheckout-offer.js — Manifesto (task 0028)
 *
 * Interstitial de upsell pré-checkout ("Leva mais uma?").
 *
 * Mecânica:
 *   1. Listener de clique em FASE DE CAPTURA no document sobre
 *      button[name="checkout"] — cobre a gaveta (#CartDrawer) e a página
 *      /cart, e sobrevive a qualquer re-render da Section Rendering API
 *      (o botão é recriado, o listener não vive nele). Hooks Dawn
 *      intocados (DP-17): nada de novo submit handler nos forms.
 *   2. Guards, EM ORDEM: dialog presente? cap de sessão não atingido?
 *      produto ofertado não entrou no carrinho depois da carga?
 *      Qualquer guard falhando ⇒ NÃO intercepta — o submit nativo segue
 *      ao /checkout, indistinguível do comportamento atual (DP-7).
 *   3. Aceite: POST /cart/add.js (variant qty 1, timeout 4s). Sucesso ⇒
 *      /checkout. Falha/timeout ⇒ mensagem discreta + /checkout após
 *      ~1,2s (fail-open, DP-6 — o interstitial JAMAIS bloqueia a venda).
 *      O add NÃO publica pub-sub de add (R-3): cart-auto-open.js nunca
 *      abre a gaveta em cima do redirect.
 *   4. Recusa (botão, X, ESC, overlay) ⇒ /checkout imediato.
 *
 * Cap de sessão (DP-5): sessionStorage mc_precheckout_offer_shown
 * (contador), compartilhado entre gaveta e /cart. Limite vem do setting
 * precheckout_session_limit ("1" | "2" | "999" = sempre).
 *
 * Telemetria (DP-10, LGPD): dataLayer precheckout_offer_shown | accepted |
 * declined | error, payload restrito a product_id, price (centavos),
 * surface ('drawer' | 'cart'). Nenhum dado pessoal.
 *
 * Sem JS: nada disso roda — os botões Finalizar submetem nativamente.
 */

(function () {
  'use strict';

  var STORAGE_KEY = 'mc_precheckout_offer_shown';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CHECKOUT_URL = '/checkout';

  var data = null;
  var surface = 'cart';
  var busy = false;
  var opened = false;
  // Marcado quando o produto ofertado entra no carrinho DEPOIS da carga
  // (pub-sub cartUpdate). Checagem local síncrona no clique — sem rede
  // (DP-6). Só marca com certeza positiva; na dúvida o modal ainda abre.
  var offerEnteredCart = false;

  function getRoot() {
    return document.getElementById('mc-precheckout-offer');
  }

  function parseData() {
    if (data) return data;
    var el = document.getElementById('mc-precheckout-offer-data');
    if (!el) return null;
    try {
      var parsed = JSON.parse(el.textContent);
      if (!parsed || !parsed.variant_id) return null;
      data = {
        variantId: Number(parsed.variant_id),
        productId: Number(parsed.product_id),
        price: Number(parsed.price),
        sessionLimit: parseInt(parsed.session_limit, 10) || 1,
      };
    } catch (err) {
      data = null;
    }
    return data;
  }

  /* ─── Cap de sessão ─── */
  function shownCount() {
    try {
      return parseInt(window.sessionStorage.getItem(STORAGE_KEY), 10) || 0;
    } catch (err) {
      return 0;
    }
  }

  function bumpShownCount() {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, String(shownCount() + 1));
    } catch (err) {
      // sessionStorage indisponível — o flag `opened` ainda limita a 1x por página.
    }
  }

  /* ─── Telemetria (payload restrito — LGPD, DP-10) ─── */
  function track(eventName) {
    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({
          event: eventName,
          product_id: data ? data.productId : null,
          price: data ? data.price : null,
          surface: surface,
        });
      }
    } catch (err) {
      // Telemetria nunca bloqueia o fluxo.
    }
  }

  /* ─── Detecção "produto entrou no carrinho depois da carga" ─── */
  function markIfOfferAdded(event) {
    var d = parseData();
    if (!d || !event) return;
    try {
      if (event.productVariantId && Number(event.productVariantId) === d.variantId) {
        offerEnteredCart = true;
        return;
      }
      var items = event.cartData && event.cartData.items;
      if (items && items.length) {
        for (var i = 0; i < items.length; i++) {
          if (Number(items[i].product_id) === d.productId || Number(items[i].id) === d.variantId) {
            offerEnteredCart = true;
            return;
          }
        }
      }
    } catch (err) {
      // Na dúvida, não marca (o modal ainda pode abrir — fail-open).
    }
  }

  function subscribeCartUpdate() {
    if (typeof window.subscribe !== 'function') return;
    try {
      var eventName =
        (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) || 'cart-update';
      window.subscribe(eventName, markIfOfferAdded);
    } catch (err) {
      // Sem pub-sub, seguimos sem a marcação (fail-open).
    }
  }

  /* ─── Navegação ─── */
  function goCheckout() {
    window.location.href = CHECKOUT_URL;
  }

  /* ─── Modal ─── */
  function openModal(root) {
    var dialog = root.querySelector('[data-mc-pco-dialog]');
    // O modal pode abrir por cima da gaveta ABERTA: o trapFocus do Dawn
    // (focusin listener instalado por CartDrawer.open) puxaria o foco de
    // volta para dentro da gaveta, por baixo do overlay. Remover o trap da
    // gaveta é seguro: ambos os caminhos do interstitial saem ao /checkout.
    if (typeof window.removeTrapFocus === 'function') {
      try {
        window.removeTrapFocus();
      } catch (err) {}
    }
    root.removeAttribute('hidden');
    // Reflow para a transição de entrada disparar a partir do estado fechado.
    void root.offsetWidth;
    root.classList.add('is-open');
    opened = true;
    bumpShownCount();
    track('precheckout_offer_shown');
    // Foco inicial no dialog (aria-labelledby anuncia o título) — nunca no
    // CTA âmbar (DP-11, sem dark pattern).
    if (dialog) {
      window.setTimeout(function () {
        try {
          dialog.focus();
        } catch (err) {}
      }, 60);
    }
  }

  function decline() {
    if (busy) return;
    busy = true;
    track('precheckout_offer_declined');
    goCheckout();
  }

  function accept(root) {
    if (busy) return;
    busy = true;

    var d = parseData();
    var cta = root.querySelector('[data-mc-pco-accept]');
    var errorEl = root.querySelector('[data-mc-pco-error]');
    if (cta) cta.classList.add('is-loading');

    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = controller
      ? window.setTimeout(function () {
          controller.abort();
        }, 4000)
      : null;

    var options = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: d.variantId, quantity: 1 }] }),
    };
    if (controller) options.signal = controller.signal;

    // Failsafe (DP-6, fail-open TOTAL): sem AbortController o fetch pode
    // pendurar sem timeout — este timer garante /checkout em <= 6s do
    // clique (critério 7) em QUALQUER cenário. Redundante nos caminhos
    // normais (a navegação torna o disparo tardio inócuo).
    var failSafe = window.setTimeout(goCheckout, 5500);

    // R-3: fetch próprio, SEM publish() de add — o cart-auto-open.js nunca
    // abre a gaveta em cima do redirect (DP-9: pós-add segue direto).
    try {
      fetch(ROOT + 'cart/add.js', options)
        .then(function (response) {
          if (timer) window.clearTimeout(timer);
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.json();
        })
        .then(function () {
          window.clearTimeout(failSafe);
          track('precheckout_offer_accepted');
          goCheckout();
        })
        .catch(function () {
          if (timer) window.clearTimeout(timer);
          window.clearTimeout(failSafe);
          // Fail-open (DP-6): mensagem discreta e segue ao checkout mesmo assim.
          if (cta) cta.classList.remove('is-loading');
          if (errorEl) errorEl.removeAttribute('hidden');
          track('precheckout_offer_error');
          window.setTimeout(goCheckout, 1200);
        });
    } catch (err) {
      // Exceção síncrona (fetch ausente/inválido): jamais deixar o cliente
      // preso com busy=true — segue ao checkout imediatamente (DP-6).
      window.clearTimeout(failSafe);
      if (timer) window.clearTimeout(timer);
      goCheckout();
    }
  }

  /* ─── Focus trap (foco preso no dialog enquanto aberto) ─── */
  function trapFocus(event, root) {
    if (event.key !== 'Tab') return;
    var dialog = root.querySelector('[data-mc-pco-dialog]');
    if (!dialog) return;
    var focusables = dialog.querySelectorAll('button:not([disabled])');
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  /* ─── Interceptação do Finalizar (fase de captura) ─── */
  function onDocumentClick(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var root = getRoot();

    // Cliques DENTRO do modal aberto (delegação — o modal é estático, mas
    // mantém o padrão de delegação do tema).
    if (root && !root.hasAttribute('hidden') && root.contains(target)) {
      if (target.closest('[data-mc-pco-accept]')) {
        accept(root);
        return;
      }
      if (target.closest('[data-mc-pco-decline]')) {
        decline();
        return;
      }
      if (target.closest('[data-mc-pco-overlay]')) {
        decline();
        return;
      }
      return;
    }

    // Interceptação do botão de checkout (gaveta + /cart + re-renders).
    var checkoutBtn = target.closest('button[name="checkout"]');
    if (!checkoutBtn || checkoutBtn.disabled) return;

    // Guards em ordem — qualquer falha ⇒ deixa o submit nativo seguir.
    if (!root) return; // enable off / sem elegível / design mode
    var d = parseData();
    if (!d) return;
    if (opened) return; // já exibido nesta página
    if (shownCount() >= d.sessionLimit) return; // cap de sessão (DP-5)
    if (offerEnteredCart) return; // cliente já pegou o produto depois da carga

    event.preventDefault();
    event.stopPropagation();

    surface = checkoutBtn.closest('#CartDrawer') ? 'drawer' : 'cart';
    openModal(root);
  }

  function onKeydown(event) {
    var root = getRoot();
    if (!root || root.hasAttribute('hidden')) return;
    if (event.key === 'Escape' || event.key === 'Esc') {
      event.preventDefault();
      decline();
      return;
    }
    trapFocus(event, root);
  }

  // Voltar do /checkout restaura a página do bfcache com o estado JS
  // congelado: modal aberto + busy=true deixaria todos os botões e o ESC
  // mortos (cliente preso atrás do overlay). Reset integral no pageshow;
  // `opened` permanece true — o modal não re-exibe nesta página.
  function onPageShow(event) {
    if (!event || !event.persisted) return;
    busy = false;
    var root = getRoot();
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('hidden', '');
    var cta = root.querySelector('[data-mc-pco-accept]');
    if (cta) cta.classList.remove('is-loading');
    var errorEl = root.querySelector('[data-mc-pco-error]');
    if (errorEl) errorEl.setAttribute('hidden', '');
  }

  function init() {
    // Sem dialog no DOM (enable off, sem elegível, design mode) ⇒ o script
    // vira no-op integral: nenhum guard chega a interceptar nada.
    subscribeCartUpdate();
    document.addEventListener('click', onDocumentClick, true);
    document.addEventListener('keydown', onKeydown);
    window.addEventListener('pageshow', onPageShow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
